export const colors = {
    DARKWHITE: '#eeeeee',
    WHITE: '#fff',
    BLACK: '#000',
    RED: "#ff1e1d",
    GREEN: "#49BF00",
    MAIN_COLOR: "#2e3c25",
    SECONDARY: "#85bb65",
    THIRDCOLOR: "#c2c9d1",
    BACKGROUND: "#2e3c25",
    GOLD:"gold",
    LIGHTGREEN:"#d7e8ca",
    DARKGREEN:"#2e3c25",
    BLUE: "#3498db",
    ORANGE: "#f39c12"
  }